import type { InputProps } from '@chakra-ui/react';
import { Input } from '@chakra-ui/react';
import {
  DesktopQuerySelector,
  MobileQuerySelector,
  textStyles,
} from '@cronos-app/chakra';
import { useTranslations } from 'next-intl';
import React, { forwardRef } from 'react';

import type { DisplayCardProps } from './DisplayCard';
import { DisplayCard } from './DisplayCard';

type InputCardProps = Omit<DisplayCardProps, 'onChange'> & {
  value: string;
  placeholder?: string;
  onChange?: InputProps['onChange'];
  onFocus?: InputProps['onFocus'];
  onBlur?: InputProps['onBlur'];
};

export const InputCard = forwardRef<HTMLInputElement, InputCardProps>(
  ({ value, placeholder, onChange, onFocus, onBlur, ...props }, ref) => {
    const t = useTranslations();

    return (
      <DisplayCard {...props}>
        <Input
          ref={ref}
          h="40px"
          type="number"
          min="0"
          placeholder={placeholder ?? t('card.input') + '...'}
          onChange={onChange}
          value={value}
          onFocus={onFocus}
          onKeyDown={(e) =>
            ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
          }
          onWheel={(e) => e.currentTarget.blur()}
          onBlur={onBlur}
          color={props.error ? 'brand.error' : 'brand.white'}
          p="0"
          border="none"
          _focus={{ outline: 'none', boxShadow: 'none', border: 'none' }}
          _placeholder={{
            textTransform: 'capitalize',
            color: 'brand.gray-scale-light-grey',
          }}
          sx={{
            [`${MobileQuerySelector}`]: {
              ...textStyles.subtitle1,
            },
            [`${DesktopQuerySelector}`]: {
              ...textStyles.h3,
            },
          }}
        />
      </DisplayCard>
    );
  },
);

InputCard.displayName = 'InputCard';
